import styled, { css } from 'styled-components';
import { BaSeTheme } from '../../theme';
import { ColorMapper } from '../../utils/color-transformation/color-mapper';

export interface SolutionsMenuProps {
  isVisible: boolean;
  background: string;
  border: string;
}

export interface LinkRedirectWrapperProps {
  hover: string;
}

interface WrapperLinkProps {
  color: string;
}

export const SolutionsWrapper = styled.div.attrs({
  className: 'BaSe--User-Apps',
})`
  position: relative;
`;

const cssMobile = css`
  grid-template-columns: 1fr;
`;

export const SolutionsMenu = styled.div.attrs({
  className: 'BaSe--User-Apps-menu',
})<SolutionsMenuProps>`
  position: absolute;
  top: 2em;
  right: -2em;
  width: 26em;
  border-radius: 0.25em;
  box-sizing: border-box;
  background: ${({ background }) => background};
  z-index: ${BaSeTheme.stackOrder.aboveOverlay};
  transition: ${BaSeTheme.transitions.allPropertiesContinuousNormal};
  border: 1px solid ${({ border }) => border};
  ${({ isVisible }) =>
    isVisible
      ? css`
          height: auto;
          box-shadow: ${BaSeTheme.shadows.profundidade8};
          opacity: 1;
        `
      : css`
          height: 0;
          padding: 0;
          overflow: hidden;
          border: none;
          opacity: 0;
        `};

  /*mobileSmall*/
  ${BaSeTheme.breakpoints.mobileSmall.mediaQueryCss(`width: 19em;`)}
  /* mobile */
  ${BaSeTheme.breakpoints.mobile.mediaQueryCss(`width: 20em;`)}
  /* mobileLarge */
  ${BaSeTheme.breakpoints.mobileLarge.mediaQueryCss(`width: 22em;`)}
`;

export const SolutionMenuHeader = styled.div`
  padding: 24px 22px 12px 12px;
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

export const SolutionHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 0.25em;
  padding: 1.25em 1em 0;
`;

export const SolutionsGrid = styled.div`
  padding: 1.25em 1em;
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 1em;

  /*mobileSmall*/
  ${BaSeTheme.breakpoints.mobileSmall.mediaQueryCss(cssMobile.toString())}
  /* mobile */
  ${BaSeTheme.breakpoints.mobile.mediaQueryCss(cssMobile.toString())}
  /* mobileLarge */
  ${BaSeTheme.breakpoints.mobileLarge.mediaQueryCss(cssMobile.toString())}
`;

export const InformationWrapper = styled.div`
  padding: 0.75em 1em 0;
`;

export const wrapperFocus = css<WrapperLinkProps>`
  .BaSe--icon-user-apps {
    background-color: ${({ color }) =>
      ColorMapper.light.hover.createTransparent(color)};
  }
  .BaSe--icon,
  .BaSe--small1 {
    cursor: pointer;
    outline: none;
    opacity: 0.7;
  }
`;

export const LinkRedirectWrapper = styled.div`
  padding: 0.75em 1em 0;
  display: flex;
  align-items: center;
  gap: 0.25em;
  justify-content: end;
  margin-bottom: 1.25em;
  &:hover,
  &:focus {
    ${wrapperFocus}
  }
`;

export const Link = styled.a`
  outline: none;
  text-decoration: none;
  cursor: inherit;
  &:focus-within,
  &:focus {
    &:focus {
      ${wrapperFocus}
    }
  }
`;

export const ButtonLink = styled.div`
  outline: none;
  cursor: inherit;
  &:focus {
    &:focus {
      ${wrapperFocus}
    }
  }
`;
